export const CARRIERS = {
  TK: {
    name: 'ターキッシュエアラインズ',
  },
  CX: {
    name: 'キャセイパシフィック航空',
  },
  SU: {
    name: 'アエロフロートロシア航空',
  },
  AZ: {
    name: 'ITAエアウェイズ',
  },
  '5J': {
    name: 'セブ・パシフィック航空',
  },
  '7C': {
    name: 'チェジュ航空',
  },
  '7G': {
    name: 'スターフライヤー',
  },
  '8M': {
    name: 'ミャンマー国際航空',
  },
  '9W': {
    name: 'ジェットエアウェイズ',
  },
  AA: {
    name: 'アメリカン航空',
  },
  AB: {
    name: 'エア・ベルリン',
  },
  AC: {
    name: 'エア・カナダ',
  },
  AD: {
    name: 'アズール・ブラジル航空',
  },
  AF: {
    name: 'エールフランス航空',
  },
  AI: {
    name: 'エア・インディア',
  },
  AK: {
    name: 'エアアジア',
  },
  AM: {
    name: 'アエロメヒコ航空',
  },
  AR: {
    name: 'アルゼンチン航空',
  },
  AT: {
    name: 'ロイヤル・エア・モロッコ',
  },
  AY: {
    name: 'フィンランド航空',
  },
  BA: {
    name: 'ブリティッシュ・エアウェイズ',
  },
  BI: {
    name: 'ロイヤル・ブルネイ航空',
  },
  BR: {
    name: 'エバー航空',
  },
  BX: {
    name: 'エアプサン',
  },
  CA: {
    name: '中国国際航空',
  },
  CI: {
    name: 'チャイナエアライン',
  },
  CZ: {
    name: '中国南方航空',
  },
  D7: {
    name: 'エアアジアＸ',
  },
  DL: {
    name: 'デルタ航空',
  },
  DN: {
    name: 'セネガル航空',
  },
  EK: {
    name: 'エミレーツ航空',
  },
  ET: {
    name: 'エチオピア航空',
  },
  EY: {
    name: 'エティハド航空',
  },
  FD: {
    name: 'タイ・エアアジア',
  },
  FI: {
    name: 'アイスランド航空',
  },
  FJ: {
    name: 'エア・パシフィック航空',
  },
  FM: {
    name: '上海航空',
  },
  GA: {
    name: 'ガルーダ・インドネシア航空',
  },
  GE: {
    name: 'トランスアジア航空',
  },
  GF: {
    name: 'ガルフ航空',
  },
  GK: {
    name: 'ジェットスター・ジャパン',
  },
  HA: {
    name: 'ハワイアン航空',
  },
  HD: {
    name: 'エアドゥ',
  },
  HR: {
    name: 'ハーンエアー',
  },
  HU: {
    name: '海南航空',
  },
  HX: {
    name: '香港航空',
  },
  HY: {
    name: 'ウズベキスタン航空',
  },
  IB: {
    name: 'イベリア航空',
  },
  JL: {
    name: '日本航空',
  },
  JP: {
    name: 'アドリア航空',
  },
  JQ: {
    name: 'ジェットスター航空',
  },
  JW: {
    name: 'バニラエア',
  },
  K6: {
    name: 'カンボジア・アンコール航空',
  },
  KA: {
    name: '香港ドラゴン航空',
  },
  KC: {
    name: 'エア・アスタナ',
  },
  KE: {
    name: '大韓航空',
  },
  KL: {
    name: 'ＫＬＭオランダ航空',
  },
  KM: {
    name: 'エアーマルタ',
  },
  KQ: {
    name: 'ケニア航空',
  },
  LH: {
    name: 'ルフトハンザドイツ航空',
  },
  LJ: {
    name: 'ジンエアー',
  },
  LO: {
    name: 'ＬＯＴポーランド航空',
  },
  LX: {
    name: 'スイス・インターナショナル・エアラインズ',
  },
  MD: {
    name: 'マダガスカル航空',
  },
  MF: {
    name: '厦門（アモイ）航空',
  },
  MM: {
    name: 'Peach',
  },
  MU: {
    name: '中国東方航空',
  },
  NH: {
    name: 'ANA',
  },
  NX: {
    name: 'マカオ航空',
  },
  OA: {
    name: 'オリンピック航空',
  },
  OM: {
    name: 'ミアットモンゴル航空',
  },
  OS: {
    name: 'オーストリア航空',
  },
  OU: {
    name: 'クロアチア航空',
  },
  OZ: {
    name: 'アシアナ航空',
  },
  PC: {
    name: 'ペガサス航空',
  },
  PG: {
    name: 'バンコクエアウェイズ',
  },
  PR: {
    name: 'フィリピン航空',
  },
  PS: {
    name: 'ウクライナ国際航空',
  },
  PX: {
    name: 'ニューギニア航空',
  },
  QF: {
    name: 'カンタス航空',
  },
  QH: {
    name: 'バンブーエアウェイズ',
  },
  QR: {
    name: 'カタール航空',
  },
  QZ: {
    name: 'インドネシア・エアアジア',
  },
  RS: {
    name: 'エアソウル',
  },
  SA: {
    name: '南アフリカ航空',
  },
  SB: {
    name: 'エアカラン',
  },
  SC: {
    name: '山東航空',
  },
  SK: {
    name: 'スカンジナビア航空',
  },
  SL: {
    name: 'タイ・ライオン・エア',
  },
  SQ: {
    name: 'シンガポール航空',
  },
  SV: {
    name: 'サウディア',
  },
  TG: {
    name: 'タイ国際航空',
  },
  TN: {
    name: 'エア タヒチ ヌイ',
  },
  TP: {
    name: 'ポルトガル航空',
  },
  TR: {
    name: 'スクート',
  },
  TW: {
    name: 'ティーウェイ航空',
  },
  UA: {
    name: 'ユナイテッド航空',
  },
  UL: {
    name: 'スリランカ航空',
  },
  UO: {
    name: '香港エクスプレス航空',
  },
  UX: {
    name: 'エアーヨーロッパ',
  },
  VN: {
    name: 'ベトナム航空',
  },
  XJ: {
    name: 'タイ・エアアジアX',
  },
  XT: {
    name: 'インドネシア・エアアジアX',
  },
  XW: {
    name: 'ノックスクート',
  },
  Z2: {
    name: 'エアアジア・ゼスト',
  },
  Z8: {
    name: 'アマゾナス航空',
  },
  ZE: {
    name: 'イースター航空',
  },
  ZH: {
    name: '深セン航空',
  },
  JH: {
    name: 'フジドリームエアラインズ',
  },
  VJ: {
    name: 'ベトジェットエアー',
  },
}
